import { FC } from "react";
import KickImage from 'Reuseables/KickImage';

//Component
import Component from "./Component";

// Interface
import { WrapperInterface } from "./definitions";

const HaveAddress: FC<WrapperInterface> = ({
  choosenAddress,
  onBack,
  seletAddress,
  continueAction
}) => {
  const { alias, full_name, phone_number, address, country, province, city, suburb, postal_code } = choosenAddress || {};

  return (<Component
    alias={alias}
    full_name={full_name}
    phone_number={phone_number}
    address={address}
    country={country}
    province={province}
    city={city}
    suburb={suburb}
    postal_code={postal_code}
    onBack={onBack}
    seletAddress={seletAddress}
    continueAction={continueAction}
  />)
}
HaveAddress.defaultProps = {
  onBack: () => { },
  seletAddress: () => { }
}

export default HaveAddress;